"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var redux_observable_1 = require("redux-observable");
var types_1 = require("../actions/internal/types");
var operators_1 = require("rxjs/operators");
var util_1 = require("./util");
var media_1 = require("../actions/internal/media");
var params_1 = require("./util/params");
function buildMediaQueryString(action) {
    var _a = action.args, eventCourseId = _a.eventCourseId, eventId = _a.eventId, bib = _a.bib, id = _a.ctEntryId;
    var params = id ?
        [{ id: id }] :
        [
            { bib: bib },
            { eventCourseId: eventCourseId }
        ];
    return "media/" + eventId + params_1.formatParams(params);
}
exports.buildMediaQueryString = buildMediaQueryString;
function startMediaPolling(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.GET_MEDIA_DATA), operators_1.flatMap(function (action$) {
        var pollingInterval = action$.pollingInterval, args = action$.args;
        return rxjs_1.from(util_1.pollForData(args, buildMediaQueryString(action$), pollingInterval, media_1.getMediaUpdateInternal, media_1.getMediaStartedInternal(args), media_1.getMediaErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }), operators_1.catchError(function (err) { return rxjs_1.of(err); }));
}
exports.startMediaPolling = startMediaPolling;
function stopMediaPolling(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.GET_MEDIA_DATA_STOP_POLLING), operators_1.flatMap(function (action$) {
        return rxjs_1.from(util_1.stopPolling(action$.args, buildMediaQueryString(action$), media_1.getMediaStoppedInternal(action$.args), media_1.getMediaErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }), operators_1.catchError(function (err) { return rxjs_1.of(err); }));
}
exports.stopMediaPolling = stopMediaPolling;
//# sourceMappingURL=mediaEpic.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/mediaEpic.js
 ** module id = 2077
 ** module chunks = 0
 **/